import { contentContainerStyle } from '@/components/ui/Layout/ContentContainer/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientDetailLayout のスタイル
 */
export const hotlineClientDetailLayoutStyle = tv({
    slots: {
        childrenWrap: ['mt-28'],
        pageTitleInner: ['mx-auto'],
        subColumnTopBorder: [],
        subColumnTopContent: ['p-16'],
        subColumnTopDescription: [
            textStyle({ color: 'base', size: 'sm' }),
            'border-t border-x-0 border-b-0 border-solid border-gray-100',
            'mt-16 pt-16',
        ],
        twoColumnWrap: [
            contentContainerStyle({ isMinWidthFull: true }),
            'mt-[30px] mx-auto mb-80',
            'lg:rounded-md',
        ],
    },
});
